<template>
  <div class="pub-page">
    <div class="pub-header d-flex align-items-center justify-content-between">
      <div>
        <text class="title me-1">{{$route.meta.title}}</text>
        <el-input clearable style="width: 200px;" placeholder="请输入登录名/姓名查询"
                  v-model="params.name"
                  @clear="reset"
                  @change="getList(true)"
                  class="me-1"></el-input>
        <el-button type="primary"  @click="getList(true)">搜索</el-button>
        <el-button type=""  @click="reset">重置</el-button>
      </div>
      <el-button type="primary"  class="ms-2 me-3" @click="handleExport">导出</el-button>
    </div>
    <div class="pub-center">
      <el-table  scrollbar-always-on   :data="list" style="width: calc(100% - 30px);position: absolute;left: 15px;top:10px;padding-bottom: 30px"  v-loading="loading">
        <el-table-column label="姓名"   >
          <template #default="scope">
            {{scope.row.real_name || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="用户名" >
          <template #default="scope">
            {{scope.row.username || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="单位" >
          <template #default="scope">
            {{scope.row.company || '-'}}
          </template>
        </el-table-column>
                <el-table-column label="职称" >
                  <template #default="scope">
                    {{scope.row.title || '-'}}
                  </template>
                </el-table-column>
        <el-table-column label="电话" >
          <template #default="scope">
            {{scope.row.tel || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="身份证/护照" >
          <template #default="scope">
            {{scope.row.id_card || '-'}}
          </template>
        </el-table-column>
                <el-table-column label="银行卡号" >
                  <template #default="scope">
                    {{scope.row.bank_card || '-'}}
                  </template>
                </el-table-column>
                <el-table-column label="开户行" >
                  <template #default="scope">
                    {{scope.row.bank_name || '-'}}
                  </template>
                </el-table-column>
      </el-table>
    </div>
    <div class="pub-footer d-flex align-items-center justify-content-center">
      <el-pagination  v-show="total>0" background
                      layout="total, sizes, prev, pager, next"
                      :page-sizes="[10, 20, 30, 40]"
                      :total="total"
                      v-model:current-page="params.current"
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"/>
    </div>
  </div>
</template>

<script setup>
import {onMounted, reactive, ref} from "vue";
import {ElMessage} from "element-plus";
import {formatTime} from "@/utils/dateFun";
import {getName, USERROLE} from "@/utils/commonSetting";
import {exportJudges, getJudges} from "@/api/specialAdmin";
import {exportMembers} from "@/api/teamsAdmin";
import {downLoadWithoutBaseUrl} from "@/utils/downloadFiles";


const params = reactive({
  pageSize:10,
  current:1,
  name:null
})
const total = ref(0)
const list = ref([])
const loading = ref(false)
onMounted(()=>{
  getList()
})
const reset = ()=>{
  params.name = ""
  getList(true)
}
// 列表
const getList = async (init)=>{
  if(init){
    params.current = 1
  }
  loading.value = true
  const res = await getJudges(params)
  loading.value = false
  if(res.success){
    total.value = res.total
    let data = res.data || []
    data.forEach(item=>{
      //  创建时间
      if(item.CreatedAt){
        item.CreatedTime = formatTime(item.CreatedAt)
      }
      if(item.Role){
        item.RoleName = getName(USERROLE,item.Role)
      }
    })
    list.value = data
  }else{
    return  ElMessage.warning("获取列表失败")
  }
}

// 导出
const handleExport =async ()=>{
  const res = await exportJudges()
  if(res.err_code===0 && res.data){
    const filesName = `评审专家.xlsx`
    downLoadWithoutBaseUrl(res.data,filesName)
  }else{
    ElMessage.warning("无法下载")
  }
}

// 页码改变
const handleSizeChange = (event) => {
  if(params.pageSize !==event){
    params.current = 1
    params.pageSize = event
    getList()
  }
}
const handleCurrentChange = ()=>{
  getList()
}

</script>

<style scoped lang="scss">


</style>
